const pageNameKey = "userManagementListPillsNav";

export const userManagementListPillsNavEn = {
  [pageNameKey]: {
    navTextUsers: "Users",
    navTextGatewayServiceUsers: "Technical Users (Gateways)",
    navTextServiceUsers: "Technical Users (API)",
  },
};

export const userManagementListPillsNavPtBr = {
  [pageNameKey]: {
    navTextUsers: "Usuários",
    navTextGatewayServiceUsers: "Usuários técnicos (gateways)",
    navTextServiceUsers: "Usuários técnicos (API)",
  },
};

export const userManagementListPillsNavDe = {
  [pageNameKey]: {
    navTextUsers: "Benutzer",
    navTextGatewayServiceUsers: "Technische Benutzer (Gateways)",
    navTextServiceUsers: "Technische Benutzer (API)",
  },
};

export const userManagementListPillsNavZhHans = {
  [pageNameKey]: {
    navTextUsers: "用户",
    navTextGatewayServiceUsers: "技术用户（网关）",
    navTextServiceUsers: "技术用户（API)",
  },
};

export const userManagementListPillsNavIt = {
  [pageNameKey]: {
    navTextUsers: "Utenti",
    navTextGatewayServiceUsers: "Utenti di servizio (gateway)",
    navTextServiceUsers: "Utenti di servizio (API)",
  },
};

export const userManagementListPillsNavEs = {
  [pageNameKey]: {
    navTextUsers: "Usuarios",
    navTextGatewayServiceUsers: "Usuarios técnicos (gateways)",
    navTextServiceUsers: "Usuarios técnicos (API)",
  },
};

export const userManagementListPillsNavNl = {
  [pageNameKey]: {
    navTextGatewayServiceUsers: "Technische gebruikers (gateways)",
    navTextServiceUsers: "Technische gebruikers (API)",
    navTextUsers: "Gebruikers",
  },
};

export const userManagementListPillsNavTr = {
  [pageNameKey]: {
    navTextGatewayServiceUsers: "Teknik Kullanıcılar (Ağ geçitleri)",
    navTextServiceUsers: "Teknik Kullanıcılar (API)",
    navTextUsers: "Kullanıcılar",
  },
};
